import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      50: "#eef7ff",
      100: "#d9ecfb",
      200: "#b8dcf5",
      300: "#85c4ed",
      400: "#4ba8df",
      500: "#1689c7",
      600: "#0f6da5",
      700: "#125986",
      800: "#164b6f",
      900: "#163f5d",
    },
    health: {
      50: "#f2f9e8",
      500: "#72ab1e",
      600: "#5d8e17",
    },
  },
  fonts: {
    heading: "euclid, system-ui, sans-serif",
    body: "euclid, system-ui, sans-serif",
  },
  styles: {
    global: {
      "html, body": {
        bg: "#f7f9fc",
        color: "gray.800",
      },
      "*::placeholder": { color: "gray.400" },
      "::selection": { bg: "brand.100", color: "brand.900" },
    },
  },
  radii: {
    xl: "14px",
    "2xl": "20px",
  },
  shadows: {
    card: "0 10px 30px rgba(16, 42, 67, 0.08)",
  },
  components: {
    Button: {
      baseStyle: { fontWeight: 600, borderRadius: "10px" },
      defaultProps: { colorScheme: "brand" },
    },
    Input: {
      defaultProps: { focusBorderColor: "brand.500" },
      variants: {
        outline: {
          field: {
            bg: "white",
            borderColor: "gray.200",
            borderRadius: "10px",
            _hover: { borderColor: "gray.300" },
          },
        },
      },
    },
    Select: {
      defaultProps: { focusBorderColor: "brand.500" },
      variants: {
        outline: {
          field: { bg: "white", borderColor: "gray.200", borderRadius: "10px" },
        },
      },
    },
    Textarea: {
      defaultProps: { focusBorderColor: "brand.500" },
      variants: {
        outline: {
          bg: "white",
          borderColor: "gray.200",
          borderRadius: "10px",
        },
      },
    },
    FormLabel: {
      baseStyle: { color: "gray.700", fontWeight: 600, fontSize: "sm" },
    },
    Modal: {
      baseStyle: { dialog: { borderRadius: "2xl", boxShadow: "card" } },
    },
  },
});

export default theme;
